import * as angular from 'angular';

import { Inject, Injectable, Optional, SkipSelf } from "@angular/core";
import { downgradeInjectable } from "@angular/upgrade/static";

import { RootScope } from '../../../../shared/ajs-bridges/ajs-providers.module';
import { HttpService } from '../../../../shared/ajs-bridges/http.service';
import { JSR310ConversionService } from '../../../../shared/jsr310-localdates/services/jsr310-conversion.service';

///////////////////////////////////////////////////////////////////////
// ATTENTION: la notion 'intervention' a ete renommee en 'operation' //
// Ne sont stockees ici que les fonctions service historiques        //
// compatibles angular-js destinees a disparaitre a fur et a mesure  //
// de la migration vers Angular                                      //
// Pour les nouvelles fonctions, voir le module: OperationModule     //
///////////////////////////////////////////////////////////////////////

@Injectable({ providedIn: 'root' })
export class DowngradableOperationService {
	private path: string;

	constructor( //
		@Inject(HttpService) private httpService: HttpService, //
		@Inject(RootScope) private rootScope: any, //
		@Inject(JSR310ConversionService) private conversionService: JSR310ConversionService, //
		@Optional() @SkipSelf() previousInstance?: DowngradableOperationService //
	) {
		if (previousInstance) {
			throw new Error(
				'This service is already loaded. Import it in the AppModule only');
		}
		this.path = (window as any).baseApiPath;
	}

	////////////////////////////
	// Gestion des evenements //
	////////////////////////////

	private static interventionPourDetail: any;

	// Gestion evenementielle pour la modale 'detail_intervention'
	private static callbackPourDetail: Function;
	watchInterventionPourDetail(callback: Function): void {
		DowngradableOperationService.callbackPourDetail = callback;
	};
	setInterventionPourDetail(intervention: any): void {
		DowngradableOperationService.interventionPourDetail = intervention;
		DowngradableOperationService.callbackPourDetail();
	};
	getInterventionPourDetail(): any {
		return DowngradableOperationService.interventionPourDetail;
	};

	// Gestion evenementielle pour la modale 'documents'
	private static callbackPourDocuments: Function;
	watchInterventionPourDocuments(callback: Function): void {
		DowngradableOperationService.callbackPourDocuments = callback;
	};
	setInterventionPourDocuments(intervention: any): void {
		DowngradableOperationService.interventionPourDetail = intervention;
		DowngradableOperationService.callbackPourDocuments();
	};
	getInterventionPourDocuments(): any {
		return DowngradableOperationService.interventionPourDetail;
	};

	// Gestion evenementielle pour la modale 'modifier_intervention'
	private static callbackPourModifier: Function;
	watchInterventionPourModifier(callback: Function): void {
		DowngradableOperationService.callbackPourModifier = callback;
	};
	setInterventionPourModifier(intervention: any, optionOuvrir: boolean): void {
		if (!intervention || intervention.parcActif) {
			DowngradableOperationService.interventionPourDetail = intervention;
			DowngradableOperationService.callbackPourModifier(optionOuvrir);
		}
	};
	getInterventionPourModifier(): any {
		return DowngradableOperationService.interventionPourDetail;
	};

	// Gestion evenementielle pour la modale 'fermer_intervention'
	private static callbackPourFermer: Function;
	private static accesPourRefresh: any;
	watchInterventionPourFermer(callback: Function): void {
		DowngradableOperationService.callbackPourFermer = callback;
	};
	setInterventionPourFermer(intervention: any, acces: any): void {
		if (acces) {
			DowngradableOperationService.accesPourRefresh = acces;
		}
		DowngradableOperationService.interventionPourDetail = intervention;
		DowngradableOperationService.callbackPourFermer();
	};
	getInterventionPourFermer(): any {
		return DowngradableOperationService.interventionPourDetail;
	};
	getAccesPourRefresh(): any {
		return DowngradableOperationService.accesPourRefresh;
	};
	resetAccesPourRefresh(): void {
		DowngradableOperationService.accesPourRefresh = null;
	};

	// Gestion evenementielle pour signaler les modifications d'interventions aux autres ecrans
	private static callbackInterventionMiseAJour: Function;
	watchInterventionMiseAJour(callback: Function): void {
		DowngradableOperationService.callbackInterventionMiseAJour = callback;
	};
	signalInterventionMiseAJour(interv: any): void {
		DowngradableOperationService.callbackInterventionMiseAJour(interv);
	};

	// Gestion evenementelle pour signaler les suppression d'inteventions aux autres ecrans
	private static callbackInterventionSupprimee: Function;
	watchInterventionSupprimee(callback: Function): void {
		DowngradableOperationService.callbackInterventionSupprimee = callback;
	};
	signalInterventionSupprimee(): void {
		DowngradableOperationService.callbackInterventionSupprimee();
	};

	// Gestion des demandes de planification d'une intervention
	private static idDemandeurPlanifIntervention: number;
	private static demandePlanifIntervention: any;
	private static callbackPlanifIntervention: Function;
	watchDemandePlanifIntervention(callback: Function): void {
		DowngradableOperationService.callbackPlanifIntervention = callback;
	};
	setDemandePlanifIntervention(demande: any): void {
		// L'utilisateur doit être identifié
		if (this.rootScope.user) {
			DowngradableOperationService.demandePlanifIntervention = demande;
			DowngradableOperationService.idDemandeurPlanifIntervention = this.rootScope.user.id;
			DowngradableOperationService.callbackPlanifIntervention();
		}
	};
	getDemandePlanifIntervention(): any {
		if (this.rootScope.user) {
			if (DowngradableOperationService.idDemandeurPlanifIntervention > 0 && DowngradableOperationService.idDemandeurPlanifIntervention != this.rootScope.user.id) {
				// Si l'utilisateur a changé : on reset la demande
				DowngradableOperationService.demandePlanifIntervention = null;
				DowngradableOperationService.idDemandeurPlanifIntervention = 0;
			}
		} else {
			// Si pas d'utilisateur : on reset la demande
			DowngradableOperationService.demandePlanifIntervention = false;
			DowngradableOperationService.idDemandeurPlanifIntervention = 0;
		}
		return DowngradableOperationService.demandePlanifIntervention;
	};

	// 
	private static callbackPourNouvelleInterPlanifiee: Function;
	watchNouvelleInterPlanifiee(callback: Function): void {
		DowngradableOperationService.callbackPourNouvelleInterPlanifiee = callback;
	};
	signalNouvelleInterPlanifiee(interv: any): void {
		// On appelle la fonction de callback si nécessaire
		DowngradableOperationService.callbackPourNouvelleInterPlanifiee(interv);
	};

	///////////////////////////////////
	// Communication avec le serveur //
	///////////////////////////////////

	// Toutes les interventions relative a une antenne
	getInterventionsByAntenne(idAntenne: number, limit_min: Date, limit_max: Date): Promise<any> {
		console.log("Appel au service Intervention pour récuperer les interventions qui concernent l'antenne " + idAntenne);

		let url: string = this.path + 'interventions/antenne/' + idAntenne;
		console.log(url);

		let parameters: any = {};
		if (limit_min) {
			parameters.limit_min = this.conversionService.toLocalDateParam(limit_min);
		}
		if (limit_max) {
			parameters.limit_max = this.conversionService.toLocalDateParam(limit_max);
		}

		// Ici on doit désactiver le cache, car il y a un bug étrange du calendrier
		// qui fait qu'il ne s'affiche pas sur les requêtes mises en cache
		let result = this.httpService.get(url, parameters);
		return result;
	};

	// Toutes les interventions de l'antenne : idAntenne
	getInterventionsEnCoursByAntenne(idAntenne: number, limit: number): Promise<any> {
		console.log("Récupération des interventions de l'antenne : id = " + idAntenne);
		let url = this.path;
		if (limit) {
			url += 'interventions/etat/en_coursWithLimit/' + idAntenne + '/' + limit;
		} else {
			url += 'interventions/etat/en_cours' + idAntenne;
		}
		console.log(url);
		let result = this.httpService.get(url);
		return result;
	};

	// Toutes les interventions de l'antenne du user connecté
	getInterventionsEnCours(limit: number): Promise<any> {
		console.log("Appel au service Interventions ");
		let url = this.path;
		if (limit) {
			url += 'interventions/etat/en_coursWithLimit/' + limit;
		} else {
			url += 'interventions/etat/en_cours';
		}
		console.log(url);
		let result = this.httpService.get(url);
		return result;
	};

	// Recupère une intervention
	getIntervention(idIntervention: number): Promise<any> {
		console.log("Appel au service Interventions id = " + idIntervention);
		let url = this.path + 'interventions/' + idIntervention;

		console.log(url);

		let result = this.httpService.get(url);

		return result;
	};

	// Recherche d'interventions via une liste de critères
	rechercheInterventions(criteresDto: any, page: number, idMax: number, sortColumn: any, sortDirection: any): Promise<any> {
		console.log("Appel au service Recherche d'interventions par critères");
		let url = this.path + 'interventions/recherche';
		console.log(url);

		let jsonData = angular.toJson(criteresDto);
		let parameters: any = {
			sortColumn: sortColumn,
			sortDirection: sortDirection
		};
		if (page != undefined && page > 0) {
			parameters.p = page;
		}
		if (idMax != undefined && idMax > 0) {
			parameters.id_max = idMax;
		}
		return this.httpService.post(url, jsonData, parameters);
	};

	// Export Excel d'interventions selon la liste des critères
	exporterInterventions(criteresDto: any): Promise<any> {
		console.log("Appel au servlet d'export d'interventions par critères");
		let url = this.path + 'interventions/export';
		console.log(url);

		let jsonData = angular.toJson(criteresDto);
		return this.httpService.post(url, jsonData);
	};

	// Planifier une intervention
	planifier(intervDto: any, ignorerAutrePlanif: boolean): Promise<any> {
		let url = this.path + 'interventions/';
		console.log("Appel au service de planification d'une intervention");
		console.log(url);
		let jsonData = angular.toJson(intervDto);
		let parameters = {
			ignorerAutrePlanif: Boolean(ignorerAutrePlanif)
		};
		let result = this.httpService.post(url, jsonData, parameters);
		return result;
	};

	//  modifier une intervention à partir de son id
	modifier(id: number, data: any): Promise<any> {
		let url = this.path + 'interventions/' + id;
		console.log("Appel au service de modification d une intervention");
		console.log(url);
		let result = this.httpService.put(url, data);
		return result;
	};

	// supprime une intervention à partir de son id
	supprimer(id: number): Promise<any> {
		let url = this.path + 'interventions/' + id;
		console.log("Appel au service de suppression d une intervention");
		console.log(url);
		let result = this.httpService.delete(url);
		return result;
	};

	// Modifier la date de début théorique d'une intervention à partir de son id
	updateDateDebutTheorique(id: number, dateDebutTheorique: Date): Promise<any> {
		let url = this.path + 'interventions/' + id + '/dateDebutTheorique/' + this.conversionService.toLocalDateParam(dateDebutTheorique);
		console.log("Appel au service de modification de la date de début théorique d'une intervention");
		console.log(url);
		let result = this.httpService.put(url, {});
		return result;
	};

	// Modifier l'url du rapport d'inter
	updateUrlRapport(id: number, newUrl: string): Promise<any> {
		let url = this.path + 'interventions/updateUrlRapport/' + id;
		console.log("Appel au service de mise a jour de l'url du rapport d'inter");
		console.log(url);
		let jsonData = {
			url: newUrl
		};
		let result = this.httpService.put(url, jsonData);
		return result;
	};

	// fermer une intervention à partir de son id 
	fermer(id: number, interventionDto: any, ignorerAccesEnCours: boolean): Promise<any> {
		let url = this.path + 'interventions/fermer/' + id + '?ignorerAccesEnCours=' + ignorerAccesEnCours;
		console.log("Appel au service de Fermer d'une intervention");
		console.log(url);
		let result = this.httpService.put(url, interventionDto);
		return result;
	};

	// Supprimer le document selon l'id
	supprimerDocument(idIntervention: number, idDocument: number): Promise<any> {
		console.log("Appel au service Document pour document : " + idDocument);
		let url = this.path + 'interventions/' + idIntervention + '/documents/supprimer/' + idDocument;

		console.log(url);

		let result = this.httpService.delete(url);

		return result;
	};

	// suggestions d'opérations selon frappe
	getSuggestions(criteria: string, quantity: number): Promise<any> {
		console.log('Appel au service de suggestion d\'operations');
		let url = this.path + 'interventions/suggestions?criteria=' + encodeURI(criteria) + '&limit=' + quantity;
		console.log(url);
		return this.httpService.get(url);
	};
}

angular
	.module('auroraApp')
	.service('downgradableOperationService', downgradeInjectable(DowngradableOperationService));